import { iono } from 'global';
import BaseComponent from '../../components/component';

/**
 * Base component class
 */
export default class Component extends BaseComponent {
  $ (selector) {
    return super.$(selector);
  }

  $$ (selector) {
    return iono.Player.UI.Utils.Dom.queryAll(selector, this.$element);
  }

  setProp (name, newValue, update = true) {
    if (this.props[name] !== newValue) {
      this.props[name] = newValue;

      if (update) this.update([name]);

      return true;
    }

    return false;
  }

  setProps (props, update = true) {
    const changed = [];

    for (const name in props) {
      if (this.setProp(name, props[name], false)) {
        changed.push(name);
      }
    }

    if (update && changed.length > 0) this.update(changed);

    return changed.length > 0;
  }

  update (changed = []) {
    if (changed.length > 0) {
      super.update();
    }
  }
}
